import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	label: {
		id: 'navigation.global-shortcuts.apps.goals',
		defaultMessage: 'Goals',
		description: 'The link label for Goals',
	},
});
